<template>
  <v-row>
    <v-col cols="12">
      <v-data-table
        :items="zClosures.reverse()"
        :headers="headers"
        no-data-text="No se han encontrado resultados !"
        class="elevation-1"
        :footer-props="{
          'items-per-page-options': [50, 100, 150, -1]
        }"
        :items-per-page="50"
      >
        <template v-slot:[`item.opened_on`]="{ item }">
          <div v-if="item.opened_on">
            <span class="day-format">
              {{ dayFormatLL(item.opened_on) }}
            </span>
            {{ formatTime(item.opened_on) }}
          </div>
        </template>
        <template v-slot:[`item.closed_on`]="{ item }">
          <div v-if="item.closed_on">
            <span class="day-format">
              {{ dayFormatLL(item.closed_on) }}
            </span>
            {{ formatTime(item.closed_on) }}
          </div>
        </template>
        <template v-slot:[`item.total_invoiced_on_credit_card`]="{ item }">
          {{ formatPrice(item.total_invoiced_on_credit_card) }}
        </template>
        <template v-slot:[`item.total_invoiced_in_cash`]="{ item }">
          {{ formatPrice(item.total_invoiced_in_cash) }}
        </template>
        <template v-slot:[`item.total_invoiced_in_datafono`]="{ item }">
          {{ formatPrice(item.total_invoiced_in_datafono) }}
        </template>
        <template v-slot:[`item.total_invoiced_in_google_pay`]="{ item }">
          {{ formatPrice(item.total_invoiced_in_google_pay) }}
        </template>
        <template v-slot:[`item.total_invoiced_in_apple_pay`]="{ item }">
          {{ formatPrice(item.total_invoiced_in_apple_pay) }}
        </template>
        <template v-slot:[`item.total_invoiced_in_bizum`]="{ item }">
          {{ formatPrice(item.total_invoiced_in_bizum) }}
        </template>
        <template v-slot:[`item.totalPrice`]="{ item }">
          {{
            formatPrice(
              Number(item.total_invoiced_on_credit_card) +
                Number(item.total_invoiced_in_cash) +
                Number(item.total_invoiced_in_datafono) +
                Number(item.total_invoiced_in_google_pay) +
                Number(item.total_invoiced_in_apple_pay) +
                Number(item.total_invoiced_in_bizum)
            )
          }}
        </template>
        <template v-slot:[`item.editAction`]="{ item }">
          <div class="d-flex justify-center">
            <font-awesome-icon
              style="cursor: pointer"
              @click="openZboxDialog(item)"
              icon="eye"
              :style="{
                color: 'black',
                fontSize: 20,
                opacity: item.closed_on ? 1 : 0.2
              }"
            />
          </div>
        </template>
      </v-data-table>
    </v-col>

    <ZboxClosureDetailDialog
      ref="zBoxClosureDetailDialog"
    ></ZboxClosureDetailDialog>
  </v-row>
</template>

<script>
import ZboxClosureDetailDialog from "./ZboxClosureDetailDialog";
import { ZboxClosuresTableHeader } from "@/utils/tableHeaderconstants";
import { getUnPaidOrdersByZcloserId } from "@/collections/unPaidOrders";
let xlsx = require("json-as-xlsx");

export default {
  name: "ZboxClosuresTable",
  components: {
    ZboxClosureDetailDialog
  },
  props: {
    z_closures: Array,
    default: null
  },
  data() {
    return {
      headers: [...ZboxClosuresTableHeader]
    };
  },
  computed: {
    zClosures() {
      return this.z_closures;
    }
  },
  methods: {
    exportToExcel(excelName) {
      let data = [
        {
          sheet: "Cierres de caja (Z)",
          columns: [
            {
              label: "NÚMERO",
              value: row => row.id
            },
            {
              label: "APERTURA",
              value: row => this.dayFormatLLAndTime(row.opened_on)
            },
            {
              label: "CIERRE",
              value: row => this.dayFormatLLAndTime(row.closed_on)
            },
            {
              label: "TARJETA",
              value: row =>
                this.formatPriceWithoutCurrency(
                  row.total_invoiced_on_credit_card
                )
            },
            {
              label: "EFECTIVO",
              value: row =>
                this.formatPriceWithoutCurrency(row.total_invoiced_in_cash)
            },
            {
              label: "DATÁFONO",
              value: row =>
                this.formatPriceWithoutCurrency(row.total_invoiced_in_datafono)
            },
            {
              label: "GOOGLE PAY",
              value: row =>
                this.formatPriceWithoutCurrency(
                  row.total_invoiced_in_google_pay
                )
            },
            {
              label: "APPLE PAY",
              value: row =>
                this.formatPriceWithoutCurrency(row.total_invoiced_in_apple_pay)
            },
            {
              label: "BIZUM",
              value: row =>
                this.formatPriceWithoutCurrency(row.total_invoiced_in_bizum)
            },
            {
              label: "BASE IMPONIBLE",
              value: row =>
                this.formatPriceWithoutCurrency(
                  this.getTaxBase(
                    Number(row.total_invoiced_on_credit_card) +
                      Number(row.total_invoiced_in_cash) +
                      Number(row.total_invoiced_in_datafono) +
                      Number(row.total_invoiced_in_google_pay) +
                      Number(row.total_invoiced_in_apple_pay) +
                      Number(row.total_invoiced_in_bizum)
                  )
                )
            },
            {
              label: "IVA (10%)",
              value: row =>
                this.formatPriceWithoutCurrency(
                  this.getIVA(
                    Number(row.total_invoiced_on_credit_card) +
                      Number(row.total_invoiced_in_cash) +
                      Number(row.total_invoiced_in_datafono) +
                      Number(row.total_invoiced_in_google_pay) +
                      Number(row.total_invoiced_in_apple_pay) +
                      Number(row.total_invoiced_in_bizum)
                  )
                )
            },
            {
              label: "TOTAL",
              value: row =>
                this.formatPriceWithoutCurrency(
                  Number(row.total_invoiced_on_credit_card) +
                    Number(row.total_invoiced_in_cash) +
                    Number(row.total_invoiced_in_datafono) +
                    Number(row.total_invoiced_in_google_pay) +
                    Number(row.total_invoiced_in_apple_pay) +
                    Number(row.total_invoiced_in_bizum)
                )
            }
          ],
          content: this.zClosures
        }
      ];
      let settings = {
        fileName: excelName, // Name of the spreadsheet
        extraLength: 3, // A bigger number means that columns will be wider
        writeOptions: {} // Style options from https://github.com/SheetJS/sheetjs#writing-options
      };

      xlsx(data, settings); // Will download the excel file
    },
    openZboxDialog(data) {
      if (!data.closed_on) {
        return;
      }

      this.$refs.zBoxClosureDetailDialog.open(
        data,
        this.getUnPaidOrders(data.id)
      );
    },
    async getUnPaidOrders(zboxClosureId) {
      try {
        let unPaidOrdersResult = [];
        if (zboxClosureId) {
          unPaidOrdersResult = await getUnPaidOrdersByZcloserId(zboxClosureId);
        }
        return unPaidOrdersResult;
      } catch (error) {
        // eslint-disable-next-line
        this.setlogError(
          "get_unPaid_orders_by_zcloserId",
          "Obtained error message in getUnPaidOrders()",
          error.stack,
          this.$options.name
        );
      }
    }
  }
};
</script>

<style scoped lang="scss">
.day-format {
  font-size: 10px;
}
.table-scroll {
  max-width: 100%;
  overflow-x: auto;
}
</style>
